import { useEffect, useState } from "react";

export const useDeviceDetector = () => {
  const [isTV, setIsTV] = useState(false);

  useEffect(() => {
    const checkTV = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isTVBrowser =
        /tv|smartTV|appletv|googletv|hbbtv|pov_tv|netcast|smarttv|web0s|tizen|viera|bravia|philipstv|roku|\bdtv\b|boxee|kuing|miray|nexplayer|trident|tv;|cehtml|opera tv|konka|selevision|inettvBrowser|sonydtv|samsungbrowser|lg app|com.webos.app|vestel|mbrowser/i.test(
          userAgent
        );
      const isForcedTV = new URLSearchParams(window.location.search).has(
        "forceTV"
      );

      setIsTV(isForcedTV || isTVBrowser);
    };

    checkTV();
  }, []);

  return isTV;
};
